import { useI18n } from '@cascade/react/i18n';
import { useProjects } from '@cascade/react/projects';
import { Button, Text } from '@cascade/ui-library';
import classes from './ProjectsFailed.module.scss';
import { Layout } from '#layout/index.ts';

export const ProjectsFailed = () => {
  const { translate, translateError } = useI18n();
  const { projectsError, reloadProjects } = useProjects();

  return (
    <Layout mode='card' title={translate('projects.failed.title')}>
      <div className={classes['projects-failed']}>
        <Text
          type='body-2'
          role='alert'
          content={translateError(projectsError)}
        />
        <Button
          label={translate('projects.failed.retry')}
          onClick={reloadProjects}
        />
      </div>
    </Layout>
  );
};
